import MathEx from "../../LTGame/LTUtils/MathEx";
import LTRes from "../../LTGame/Res/LTRes";
import GlobalUnit from "../common/GlobalUnit";
import ResDefine from "../common/ResDefine";
export default class HpItem {
    constructor(owner, max) {
        this.curHp = this.maxHp = max;
        this.owner = owner;
        this.CreateModel();
        this.UpdateBar(this.curHp);
        this.SyncPos();
    }
    CreateModel() {
        this.rootObj = LTRes.Get(ResDefine.FixPath(ResDefine.HpPath));
        GlobalUnit.game.level.AddItemToLevel(this.rootObj);
        this.rootObj.transform.localScale = this.owner.rootObj.transform.localScale;
        this.rootObj.transform.localScaleZ *= -1;
        this.bar = this.rootObj.getChildAt(0).getChildByName("bar");
    }
    UpdateBar(curHp) {
        if (this.rootObj.destroyed)
            return;
        this.curHp = curHp;
        this.bar.transform.localScaleX = MathEx.Clamp(this.curHp / this.maxHp, 0, 1);
        this.rootObj.active = this.curHp < this.maxHp;
    }
    SyncPos() {
        this.rootObj.transform.position = this.owner.rootObj.transform.position;
        this.rootObj.transform.localPositionY += this.owner.rootObj.transform.getWorldLossyScale().x * 2.2;
        this.rootObj.transform.rotationEuler = GlobalUnit.game.camera.camera.transform.rotationEuler;
    }
    Destroy() {
        this.rootObj.destroy();
    }
}
